import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const MemberRegistration = lazy(() => import('../../container/borrower/member/memberRegistration'));
const MemberList = lazy(() => import('../../container/borrower/member/memberList'));

function MemberRoute() {
  return (
    <Routes>
      <Route path="registration" element={<MemberRegistration />} />
      <Route path="list" element={<MemberList />} />
    </Routes>
  );
}

export default MemberRoute;
